import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { CONTEXT_API_RECUPERER_ADRESSE_LISTE_EXTENSION } from '../../constants/apiUrls.constants';

const adresseExtensions = combineReducers({
    recupererListe: APIReducer.bind(null, CONTEXT_API_RECUPERER_ADRESSE_LISTE_EXTENSION),
});

export default adresseExtensions;
